function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import React from 'react';
import classnames from 'classnames';
import deprecate from 'util-deprecate';
import Label from '../../atoms/Label';
import TextBox from '../../atoms/TextBox';
import TextBoxWithIcon from '../TextBoxWithIcon/TextBoxWithIcon';
/**
 * Status: *in progress*.
 * Category: FormElements
 **/

var TextBoxWithLabel = /*#__PURE__*/React.forwardRef(deprecate(function (_ref, ref) {
  var labelText = _ref.labelText,
      type = _ref.type,
      placeholder = _ref.placeholder,
      hideLabel = _ref.hideLabel,
      errorMessage = _ref.errorMessage,
      disabled = _ref.disabled,
      withIcon = _ref.withIcon,
      iconName = _ref.iconName,
      iconColor = _ref.iconColor,
      iconIsButton = _ref.iconIsButton,
      iconLabel = _ref.iconLabel,
      rest = _objectWithoutProperties(_ref, ["labelText", "type", "placeholder", "hideLabel", "errorMessage", "disabled", "withIcon", "iconName", "iconColor", "iconIsButton", "iconLabel"]);

  return /*#__PURE__*/React.createElement(Label, {
    className: classnames('textbox-with-label', {
      'textbox-with-label--with-error': errorMessage
    }),
    isUsingGrayText: true
  }, /*#__PURE__*/React.createElement("span", {
    className: classnames('textbox-with-label__label-text', {
      'sr-only': hideLabel
    })
  }, labelText), withIcon ? /*#__PURE__*/React.createElement(TextBoxWithIcon, _extends({
    ref: ref,
    type: type,
    placeholder: placeholder,
    disabled: disabled,
    error: !!errorMessage,
    iconName: iconName,
    iconColor: iconColor,
    iconIsButton: iconIsButton,
    iconLabel: iconLabel,
    "aria-invalid": !!errorMessage
  }, rest)) : /*#__PURE__*/React.createElement(TextBox, _extends({
    ref: ref,
    type: type,
    placeholder: placeholder,
    disabled: disabled,
    error: !!errorMessage,
    "aria-invalid": !!errorMessage
  }, rest)), errorMessage && /*#__PURE__*/React.createElement("p", {
    role: "alert",
    className: "input-error",
    "aria-live": "polite"
  }, errorMessage));
}, '<TextBoxWithLabel/> from Telia Styleguide is a deprecated component. Use <TextField/> instead'));
TextBoxWithLabel.displayName = 'TextBoxWithLabel';
TextBoxWithLabel.defaultProps = {
  iconColor: 'black',
  placeholder: '',
  onChange: function onChange() {}
};
export default TextBoxWithLabel;